
const isError_ = require('lodash/isError')
const negate_ = require('lodash/negate')
const {
  extendConsoleError,
  isAppInvolvedWithError,
  addUnhandledRejectionListener,
  shouldReportException,
  reportException
} = require('dbsm-common/src/raven/supplementaryErrorHandlers')

const isErrorHandled = require('../error-boundaries/errorBoundaries')

module.exports = (Raven, globalScope, appName) => {
  const handleException = error => {
    if (shouldReportException(error, isError_, negate_(isErrorHandled), isAppInvolvedWithError(appName))) {
      reportException(error, appName, Raven, {tags: {errorBoundaries: 'non-scoped'}})
    }
  }

  extendConsoleError(globalScope, (...args) => handleException(args[0]))
  addUnhandledRejectionListener(global, evt => handleException(evt.reason))
}



// WEBPACK FOOTER //
// ./raven/registerRavenToUnexpectedErrors.js